//----- Component --------------------------------------------------------/
// Developer     : Guillermo Sedran
// Creation Date : 15/10/2025
// Version       : 1
// Description   : Activar/Anular relacion entre tipo de vehiculos y componentes
//
//------Changes --------------------------------------------------------------------- -------------//
// Change Date   :
// Change by     :
// Change description:
//
// Change Date   :
// Change by     :
// Change description:
//
//========================================================================/

import React, { useState } from "react";
import { UrlApi } from "../../../../../services/apirest";
import {
  Box,
  DialogActions,
  DialogContent,
  DialogTitle,
  Button,
  Typography,
  Stack,
  Snackbar,
} from "@mui/material";

//Notification
import MuiAlert from "@mui/material/Alert";

// ICONOS
import LinkIcon from "@mui/icons-material/Link";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function CambiarEstadoRelacion(props) {
  const isRelacionActiva = props.relacion.estado === 1;

  // Deshabilitar Botón
  const [disBtn, setDisBtn] = useState(false);

  //Notification
  const [openSnack, setOpenSnack] = React.useState(false);
  const [colormensaje, setColorMensaje] = useState("");
  const [mensaje, setMensaje] = useState("");

  // ------------------------------------------------------------------

  // FUNCIONES PARA GUARDAR RELACIÓN
  const guardarActivo = async () => {
    await fetch(
      UrlApi +
        "/relacion_tiposv_componentes/" +
        encodeURIComponent(props.relacion.id),
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          estado: 1, // Activar
        }),
      }
    )
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("La relación se activó exitosamente!");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al activar la relación");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  const guardarInactivo = async () => {
    await fetch(
      UrlApi +
        "/relacion_tiposv_componentes/" +
        encodeURIComponent(props.relacion.id),
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          estado: 2, // Desactivar
        }),
      }
    )
      .then((res) => {
        if (!res.err) {
          setOpenSnack(true);
          setColorMensaje("#D4EFDF");
          setMensaje("La relación se desactivó exitosamente!");
        } else {
          setOpenSnack(false);
          setColorMensaje("#F1948A");
          setMensaje("Error al desactivar la relación");
        }
      })
      .catch((err) => {
        console.log(err.message);
      });
  };

  // -------------------------------------

  // Manejar el guardado de estado
  const handleGuardarRelacion = () => {
    if (isRelacionActiva) {
      setDisBtn(true);
      guardarInactivo(props.relacion); // Si está activo, lo desactiva
    } else {
      setDisBtn(true);
      guardarActivo(props.relacion); // Si está inactivo, lo activa
    }
  };

  //*************************************************************************************************************************************/

  // Snackbar Notificacion
  // Cerrar el Snackbar y realizar las acciones finales
  const handleCloseSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setDisBtn(false);
    setOpenSnack(false);

    // Acciones de cierre de diálogo y actualización después de que el Snack se cierre
    props.onRelacionGuardada(); // Función para obtener valores de nuevo en el componente padre
    props.handleCloseCambiarEstadoRelacion();
  };

  return (
    <>
      <Box>
        <Box
          sx={{
            backgroundColor: "#2B76A6",
            width: "100%",
            textAlign: "center",
          }}
        >
          <DialogTitle alignSelf="center" mb={1}>
            <Typography
              sx={{
                color: "white",
                fontWeight: "bold",
              }}
            >
              {isRelacionActiva ? "ANULAR" : "ACTIVAR"} RELACIÓN
            </Typography>
          </DialogTitle>
        </Box>
      </Box>

      <DialogContent sx={{ textAlign: "center", py: 1 }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: 1,
            p: 2,
            mx: "auto",
            maxWidth: "280px",
            borderRadius: 2,
            backgroundColor: "#f8f9fa",
            border: "1px solid #e0e0e0",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              fontWeight: 500,
              color: "text.primary",
            }}
          >
            {props.relacion.tipo_vehiculo}
          </Typography>
          <LinkIcon sx={{ color: "#2B76A6" }} />
          <Typography
            variant="body1"
            sx={{
              fontWeight: 500,
              color: "text.primary",
            }}
          >
            {props.relacion.componente}
          </Typography>
        </Box>

        {/* Texto de confirmación */}
        <Typography
          align="center"
          sx={{
            fontWeight: "bold",
            mt: 3,
            mb: 2,
            fontSize: "1.1rem",
            color: "text.primary",
          }}
        >
          {isRelacionActiva
            ? "¿Desea anular esta relación?"
            : "¿Desea activar esta relación?"}
        </Typography>
      </DialogContent>

      <DialogActions>
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Button
            variant="contained"
            color="error"
            sx={{
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
            }}
            onClick={props.handleCloseCambiarEstadoRelacion}
            disabled={disBtn}
          >
            Volver
          </Button>
          <Button
            sx={{
              borderRadius: "12px",
              textTransform: "none",
              fontWeight: 600,
            }}
            onClick={handleGuardarRelacion}
            variant="contained"
            disabled={disBtn}
          >
            {isRelacionActiva ? "Anular" : "Activar"}
          </Button>
        </Box>
      </DialogActions>

      {/* SNACKBAR QUE SE MOSTRARÁ AL GUARDAR LOS CAMBIOS */}
      <Stack spacing={2} sx={{ width: "100%" }}>
        <Snackbar
          open={openSnack}
          autoHideDuration={1500}
          onClose={handleCloseSnack}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
        >
          <Alert
            onClose={handleCloseSnack}
            severity="success"
            sx={{ width: "100%" }}
            style={{ backgroundColor: colormensaje, color: "black" }}
          >
            {mensaje}
          </Alert>
        </Snackbar>
      </Stack>
    </>
  );
}

export default CambiarEstadoRelacion;
